import searchFilters from '@/constants/searchFilters'
import { createSlice, createSelector } from '@reduxjs/toolkit'
import apiWrapper from '@/utils/apiHelpers/apiWrapper'
import { HYDRATE } from 'next-redux-wrapper'
import { deleteEmptyProps } from '@/utils/objectHelper'

const { SEARCH_BY_PUBLICATION } = searchFilters

const clearFilters = {
  model: '',
  modelType: '',
  lineOffDate: ''
}
const initialPagination = {
  page: 1,
  limit: 10,
  sortBy: { column: 'partNumber', type: 'asc' }
}

const initialState = {
  query: {
    filterBy: {
      searchBy: SEARCH_BY_PUBLICATION,
      brand: '',
      model: '',
      modelType: '',
      publicationType: '',
      language: '',
      partNumber: '',
      lineOffDate: '',
      year: '',
      metadata: '',
      contentSubType: '',
      katashiki: ''
    },
    pagination: initialPagination
  },
  results: {
    publications: {},
    topics: {}
  },
  pane: {}
}

const setResults =
  resultType =>
  (state, { payload: { items, page = null, limit = null, total } }) => {
    state.results[resultType] = { items, page: page + 1, limit, total }
  }

const search = createSlice({
  name: 'search',
  initialState,
  reducers: {
    SET_FILTERS: (state, { payload }) => {
      state.query.filterBy = payload
    },
    UPDATE_FILTERS: (state, { payload }) => {
      state.query.filterBy = { ...state.query.filterBy, ...payload }
    },
    RESET_FILTERS: state => {
      const { brand } = state.query.filterBy
      state.query.filterBy = { ...initialState.query.filterBy, brand }
    },
    SET_BRAND: (state, { payload }) => {
      state.query.filterBy = {
        ...state.query.filterBy,
        ...clearFilters,
        brand: payload
      }
    },
    SET_PAGINATION: (state, { payload }) => {
      state.query.pagination = payload
    },
    UPDATE_PAGINATION: (state, { payload }) => {
      state.query.pagination = { ...state.query.pagination, ...payload }
    },
    RESET_PAGINATION: state => {
      state.query.pagination = initialPagination
    },
    SET_PUBLICATIONS_RESULT: setResults('publications'),
    SET_PANE: (state, { payload }) => {
      state.pane = payload
    }
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action) => {
      if (action.payload.search) {
        const { search } = action.payload
        return {
          ...state,
          query: {
            ...state.query,
            filterBy: {
              ...state.query.filterBy,
              ...deleteEmptyProps(search.query.filterBy),
              brand: state.query.filterBy.brand || search.query.filterBy.brand
            },
            pagination: {
              ...state.query.pagination,
              ...deleteEmptyProps(search.query.pagination)
            }
          },
          results: {
            ...state.results,
            ...search.results
          },
          pane: {
            ...state.pane,
            ...deleteEmptyProps(search.pane)
          }
        }
      }
      return state
    })
  }
})

export const searchActions = search.actions

export const getPane = async filters => {
  const { brand, model, modelType, ngtdModelId, generationId, language } = filters
  const pane = { modelType }
  if (language) pane.language = language
  if (brand && model && modelType && ngtdModelId) {
    const generations = await apiWrapper.get(
      `vehicles/${brand}/model/${model}/modelType/${modelType}/generations/${ngtdModelId}`
    )
    if (generations.length && generationId) {
      pane.generation = generations.find(g => g.id === generationId)
    }
  }
  return pane
}

export default search

const selectTopicResults = ({ search }) => search?.topics?.items

const selectQuery = ({ search }) => search?.query

const selectTopicMetadata = createSelector(
  [selectTopicResults, selectQuery],
  (topics, query) => topics && query.filters.metadata
)

export const searchSelectors = {
  selectSearch: ({ search }) => search,
  selectQuery,
  selectResults: ({ search }) => search?.results,
  selectTopicResults,
  selectTopicMetadata,
  selectPane: ({ search }) => search.pane,
  selectBrand: ({ search }) => search.query?.filterBy?.brand
}
